// The emails about the reader's own account (5 Nov 2026): the sign-up welcome, "your plan is live" and "your
// plan is cancelled". The worker decides and sends each once (cloudflare/account-mail.mjs); the page only asks it
// to look. Asked once a day per browser while signed in (like activeDay.ts), and by the account page's plan card
// when it shows a plan or after a cancel. Nothing is sent from here and nothing about the reader is sent to it.
const KEY = "sn-account-mail";
const indiaDay = () => new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10);

export function askAccountMail(token: string | undefined) {
  if (!token) return;
  fetch("/api/data/account-mail", { method: "POST", headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
}

export function noteAccountMail(token: string | undefined, userId: string | undefined) {
  try {
    if (!token || !userId || document.hidden) return;
    const mark = userId + ":" + indiaDay();
    if (localStorage.getItem(KEY) === mark) return;
    fetch("/api/data/account-mail", { method: "POST", headers: { Authorization: `Bearer ${token}` } })
      .then((r) => { if (r.ok) localStorage.setItem(KEY, mark); }).catch(() => {});
  } catch { /* storage refused: nothing asked */ }
}
